import type {
  ReactElement,
} from 'react';

import { Autocomplete as AutocompleteBase } from '@n3/react-autocomplete';
import type {
  AutocompleteProps as AutocompleteBaseProps,
} from '@n3/react-autocomplete';

import { components } from './components';

export type AutocompleteProps<Option> = Omit<AutocompleteBaseProps<Option>, 'components'>;

export function Autocomplete<Option>(props: AutocompleteProps<Option>): ReactElement {
  return (
    <AutocompleteBase
      {...props}
      components={components}
    />
  );
}
